<template>
  <div v-if="showFullScreenBtn" class="full-screen-btn-con">
    <Tooltip :content="currentValue ? '退出全屏' : '全屏'" placement="bottom">
      <Icon @click.native="handleChange" :type="currentValue ? 'md-contract' : 'md-expand'" :size="23"></Icon>
    </Tooltip>
  </div>
</template>

<script>
const OPEN_LIST = ['requestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullScreen', 'msRequestFullscreen']
const CLOSE_LIST = ['exitFullscreen', 'mozCancelFullScreen', 'webkitCancelFullScreen', 'msExitFullscreen']
export default {
  name: 'Fullscreen',
  computed: {
    showFullScreenBtn () {
      return window.navigator.userAgent.indexOf('MSIE') < 0
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: false
    }
  },
  watch: {
    value: {
      handler () {
        this.currentValue = this.value
      },
      immediate: true
    }
  },
  methods: {
    open () {
      let main = document.body
      for (let i = 0; i < OPEN_LIST.length; ++i) {
        let fn = OPEN_LIST[i]
        if (typeof main[fn] === 'function') {
          main[fn]()
          break
        }
      }
    },
    close () {
      for (let i = 0; i < CLOSE_LIST.length; ++i) {
        let fn = CLOSE_LIST[i]
        if (typeof document[fn] === 'function') {
          document[fn]()
          break
        }
      }
    },
    handleFullscreen () {
      // let main = document.body
      let isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
      isFullscreen = !!isFullscreen
      if (isFullscreen) {
        this.close()
      } else {
        this.open()
      }
    },
    handleChange () {
      this.handleFullscreen()
    }
  },
  mounted () {
    let isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
    isFullscreen = !!isFullscreen
    document.addEventListener('fullscreenchange', () => {
      let value = !this.value
      this.$emit('input', value)
      this.$emit('on-change', value)
    })
    document.addEventListener('mozfullscreenchange', () => {
      let value = !this.value
      this.$emit('input', value)
      this.$emit('on-change', value)
    })
    document.addEventListener('webkitfullscreenchange', () => {
      let value = !this.value
      this.$emit('input', value)
      this.$emit('on-change', value)
    })
    document.addEventListener('msfullscreenchange', () => {
      let value = !this.value
      this.$emit('input', value)
      this.$emit('on-change', value)
    })
    // this.$dom.on(window, 'keydown', (e) => {
    //   let keyCode = e.keyCode || e.charCode
    //     debugger
    //   if (keyCode === 122) {
    //     // F11
    //     let value = !this.value
    //     this.$emit('input', value)
    //     this.$emit('on-change', value)
    //   }
    // })
    // document.addEventListener('keydown', (e) => {
    //   let keyCode = e.keyCode || e.charCode
    //   debugger
    //   if (keyCode === 122) {
    //     // F11
    //     let value = !this.value
    //     this.$emit('input', value)
    //     this.$emit('on-change', value)
    //   }
    // })
    this.$emit('input', isFullscreen)
  }
}
</script>

<style lang="less">
.full-screen-btn-con .ivu-tooltip-rel{
  height: 64px;
  line-height: 56px;
  i{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/main/components/fullscreen/fullscreen.vue